import { Theme } from "@mui/material/styles";

export const formLabelStyles = (theme: Theme) => ({
  fontSize: "0.875rem",
  fontWeight: 500,
  marginBottom: "4px",
  display: "flex",
  alignItems: "center",
  color: theme.palette.mode === "light" ? "#333" : "#ffffff",
  "& .MuiFormLabel-asterisk": {
    color: "red",
  },
  "& svg": {
    marginRight: "4px",
    fontSize: "1rem",
  },
});
